// Services/activity/SlBreached.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const Sl_breached = createApi({
  reducerPath: "sl_breached",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,

  endpoints: (builder) => ({
    // Single endpoint that returns both tickets and emails
    slBreached: builder.query({
      query: ({
        currentPage,
        selectedActiveFilters1,
        isFilterOn,
        selectedWorkFlow,
        task_source,
        pageSize,
        sl_type,
      }) => {
        let baseUrl = `v1/tickets/activity-tasks/sl-breach/${task_source}/?workflow_name=${
          selectedWorkFlow || ""
        }&page=${currentPage}&page_size=${pageSize}`;

        if (sl_type) {
          baseUrl += `&sl_type=${encodeURIComponent(sl_type)}`;
        }

        const filterParams = isFilterOn
          ? `&filters=on${getFilterParams(selectedActiveFilters1)}`
          : "";

        return `${baseUrl}${filterParams}`;
      },
    }),
  }),
});

export const { useSlBreachedQuery } = Sl_breached;

function getFilterParams(selectedFilterAndValue1: Record<string, unknown>) {
  const filterParams = Object.entries(selectedFilterAndValue1)
    .filter(
      ([key, value]) =>
        value !== "" &&
        key !== "workflow_stage",
    )
    .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
    .join("&");

  return filterParams ? `&${filterParams}` : "";
}
